import getUnixTime from 'date-fns/getUnixTime';

/**
 * @deprecated This helper is deprecated. Use the @dealroadshow/uikit-date-time class with appropriate methods instead.
 */
export const getUnixTimestamp = (date: Date = new Date()): number => getUnixTime(date);
/**
 * @deprecated This helper is deprecated. Use the @dealroadshow/uikit-date-time class with appropriate methods instead.
 */
export const getUnixTimestampInMilliseconds = (date: Date = new Date()): number => date.valueOf();

export default getUnixTimestamp;
